import type { CertificateRule } from '~/pages/backoffice/admin/sessions/certificate-rule-form'
import { CertificateCondition } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { Input } from '~/components/ui/input'
import { CERTIFICATE_CONDITION_KEYS, withCondition } from '~/pages/backoffice/admin/sessions/certificate-rule-form'
import { minScoreFromPercent } from '~/pages/backoffice/admin/sessions/session-path-form'

type IProps = {
  value: CertificateRule
  onChange: (rule: CertificateRule) => void
  /** Seuil proposé au passage au score : celui du premier module qui en déclare un. */
  suggestedMinScore: number
}

/** Ce qu'exige l'attestation du parcours (#10) : la règle elle-même est appliquée par l'API. */
function CertificateConditionFields({ value, onChange, suggestedMinScore }: IProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1.5 sm:col-span-2">
      <label className="text-sm font-medium" htmlFor="session-certificate">{t('sessions.certificate.label')}</label>
      <div className="flex flex-wrap items-center gap-2">
        <select
          id="session-certificate"
          value={value.condition}
          onChange={e => onChange(withCondition(value, e.target.value as CertificateCondition, suggestedMinScore))}
          className="h-9 flex-1 rounded-md border border-input bg-transparent px-3 text-sm"
        >
          {Object.entries(CERTIFICATE_CONDITION_KEYS).map(([condition, key]) => (
            <option key={condition} value={condition}>{t(key)}</option>
          ))}
        </select>
        {value.condition === CertificateCondition.SCORE && (
          <span className="flex items-center gap-1.5 text-sm">
            <Input
              type="number"
              min={1}
              max={100}
              className="h-9 w-20"
              aria-label={t('sessions.certificate.minScore')}
              value={Math.round((value.minScore ?? suggestedMinScore) * 100)}
              onChange={e => onChange({ ...value, minScore: minScoreFromPercent(e.target.value) })}
            />
            %
          </span>
        )}
      </div>
      <p className="text-xs text-muted-foreground">{t('sessions.certificate.hint')}</p>
    </div>
  )
}

export default CertificateConditionFields
